export const open_nav = () => {
  return (dispatch) => {
    dispatch({
      type: "open",
    });
  };
};

export const close_nav = () => {
  return (dispatch) => {
    dispatch({
      type: "close",
    });
  };
};

export const open_Mnav = () => {
  return (dispatch) => {
    dispatch({
      type: "open",
    });
  };
};

export const close_Mnav = () => {
  return (dispatch) => {
    dispatch({
      type: "close",
    });
  };
};

export const productChangeFilter = (filter) => {
  // console.log("why------------");
  return (dispatch) => {
    dispatch({
      type: filter,
    });
  };
};

export const ExamChangeFilter = (filter) => {
  // console.log("where------------");
  return (dispatch) => {
    dispatch({
      type: filter,
    });
  };
};

// --------------Cart-----------------------------------

export const addToCart = (ID) => {
  return (dispatch) => {
    dispatch({
      type: "add",
      id: ID,
    });
  };
};

export const removeFromCart = (ID) => {
  return (dispatch) => {
    dispatch({
      type: "remove",
      id: ID,
    });
  };
};

//calendar----------------------------------------------

export const selectDay = (Year, Month, Day) => {
  return (dispatch) => {
    dispatch({
      type: "daySelect",
      year: Year,
      month: Month,
      day: Day,
    });
  };
};

export const showEvent = (Exams) => {
  return (dispatch) => {
    dispatch({
      type: "showEvent",
      exams: Exams,
    });
  };
};

// --------------------------------------------------

export const showNav = () => {
  return (dispatch) => {
    dispatch({
      type: "show",
    });
  };
};

//MNav data change-----------------------------------
export const homeNav = () => {
  return (dispatch) => {
    dispatch({
      type:"home",
    });
  };
};

export const dashNav = () => {
  return (dispatch) => {
    dispatch({
      type:"dashboard",
    });
  };
};
//-------------------------------------------------
// @create-index

export { default as chat } from "./chat.js";
// export { default as message } from './message.js';
export { default as publicApi } from "./public.js";
export { default as user } from "./user.js";
export { default as qr } from "./qr.js";
export { default as book } from "./book.js";
export { default as userProduct } from "./userProduct.js";
export { default as userFactor } from "./userFactor.js";
export { default as transport } from "./transport.js";
export { default as comment } from "./comment.js";
export { default as activation } from "./activation.js";
export { default as file } from "./file.js";
